import { ErrorService } from 'services/error-service';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ServiceStationService } from 'services/service-station-service';
import { connectTo } from 'aurelia-store';
import { ApplicationState } from 'lib/state';

@autoinject
@connectTo()
export class ServiceStationList {
  protected tableData: Array<Models.ServiceStation>;
  protected ready: boolean = false;
  protected activeTableRow: number;
  protected state: ApplicationState;
  protected isAdmin: boolean = false;

  constructor(private router: Router, private serviceStationService: ServiceStationService, private errorService: ErrorService) {}

  private async getAllServiceStations() {
    try {
      //If the user have SuperService role only get their servicestation, else get all the servciestations
      if (this.state.roles.includes('SuperService') && !this.state.roles.includes('Administrator')) {
        this.tableData = await this.serviceStationService.getAll(
          `$orderby=Name&$expand=ErpSystem&$filter=id eq ${this.state.user.ServiceStationId}`
        );
        this.isAdmin = false;
      } else {
        this.tableData = await this.serviceStationService.getAll('$orderby=Name&$expand=ErpSystem');
        this.isAdmin = true;
      }
      this.ready = true;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async attached() {
    await this.getAllServiceStations();
  }

  protected gotoDetailView(id: number) {
    this.activeTableRow = id;
    this.router.navigateToRoute('service-station-main', { Id: id });
  }
}
